import LanguageDetail from './LanguageDetail';

export default LanguageDetail;



// WEBPACK FOOTER //
// ./src/scenes/Languages/LanguageDetail/index.ts